import { ICustomReservationThreshold } from "../../interfaces/endpoints/ICustomReservationThreshold";

// How one threshold row reads. The API names both endpoints and the operator for the page, so these
// only decide what to show — nothing here fetches anything.

// A name the API could not resolve means the row points at something deleted; show the id rather than
// an empty cell, so the row can still be recognised and fixed.
export const renderName = (
  name: string | null,
  id: number | null
): JSX.Element | string | null => {
  if (name) return name;
  if (id === null) return null;
  return <span className="text-gray-400 text-xs">#{id}</span>;
};

export const fromId = (row: ICustomReservationThreshold): number | null =>
  row.fromCountryId ?? row.fromCityId ?? row.fromStationId;

export const toId = (row: ICustomReservationThreshold): number | null =>
  row.toCountryId ?? row.toCityId ?? row.toStationId;

// What the row is about, in one word for the "Tipi" cell.
export const thresholdType = (row: ICustomReservationThreshold): string =>
  row.fromCountryId !== null
    ? "Shtet"
    : row.fromCityId !== null
    ? "Qytet"
    : "Stacion";

// Only a station rule can be limited to one operator; the wider two always apply to everybody.
export const renderOperator = (
  row: ICustomReservationThreshold
): JSX.Element | string | null => {
  if (row.fromCountryId !== null || row.fromCityId !== null) {
    return <span className="text-gray-400 italic">-</span>;
  }
  if (row.operatorId === null) {
    return <span className="text-gray-400 italic">Te gjithe</span>;
  }
  return renderName(row.operatorName, row.operatorId);
};
